import { EChartsOption, LineSeriesOption } from "echarts";
import { WriterEssayDraftHistoryViewModel } from "./essayDraftHistoryReportApiSlice";

export function getXAxisFromMaxDraftCount(writers: WriterEssayDraftHistoryViewModel[]): string[] {
	if (!writers || writers.length === 0) {
		return [];
	}

	const maxDrafts = writers.reduce((maxDrafts, writer) => {
		const writerDrafts =
			writer.essays?.reduce((accum, essay) => accum + (essay.drafts?.length ?? 0), 0) ?? 0;

		return Math.max(maxDrafts, writerDrafts);
	}, 0);

	return Array.from({ length: maxDrafts }, (_, i) => "Draft " + (i + 1));
}

export const getSeriesData = (data: WriterEssayDraftHistoryViewModel[], foregroundColor: string) =>
	data.map((d): LineSeriesOption => buildSeriesProps(d, foregroundColor));

function buildSeriesProps(
	data: WriterEssayDraftHistoryViewModel,
	foregroundColor: string
): LineSeriesOption {
	return {
		type: "line",
		name: `${data.writerFormalFullName}`,
		connectNulls: true,
		data: data.essays.flatMap((essay) => essay.drafts.map((draft) => draft.draftScore)),
		label: {
			show: true,
			color: foregroundColor,
		},
		lineStyle: {
			type: "solid",
		},
		emphasis: {
			focus: "series",
		},
	};
}

export function updateOptions(
	options: EChartsOption,
	seriesData: LineSeriesOption[]
): EChartsOption {
	options.series = seriesData;
	return options;
}
